import Vue from "vue";
import "dayjs/locale/ru";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
// import relativeTime from "dayjs/plugin/relativeTime";
// import LocalizedFormat from "dayjs/plugin/localizedFormat";
// import utc from "dayjs/plugin/utc";

dayjs.locale("ru");
dayjs.extend(customParseFormat);
// dayjs.extend(relativeTime);
// dayjs.extend(LocalizedFormat);
// dayjs.extend(utc);
Vue.prototype.$dayjs = dayjs;

export default dayjs;
